<div class="loader absolute" *ngIf="isLoading">
  <svg class="circular" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
  </svg>
</div>
<div class="plan-container" *ngIf="!isLoading">
  <div [className]="currentPlanType === 1 ? 'plan current-standard' : 'plan'" style="margin-right: 4px">
    <div class="plan-top">
      <div class="plan-title">Basic
        <div class="current-basic-badge" *ngIf="currentPlanType === 1">Current</div>
      </div>
      <div class="plan-price" *ngIf="isHasStandardPlanFee()">
        <div *ngIf="isHasViewPricePermission" style="margin-bottom: 8px; display: flex; align-items: flex-end;">
          <div class="price">{{me()?.currency_symbol}}{{dealerPlanService.dealerPlanPriceStandard}}</div>
          <div style="display: flex; flex-direction: column; margin-left: 8px">
            <div style="font-size: 14px;">/month per Dealer Account</div>
          </div>
        </div>
      </div>
      <div class="plan-price" *ngIf="!isHasStandardPlanFee()"><i class="material-icons" style="color: #8792A2; font-size: 60px">forum</i>
        <div class="plan-description">No monthly dealer fee.</div>
      </div>
    </div>
    <div class="plan-contents">
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>Maintain Current Features</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>30 Days Cloud Video Storage</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-blue-gray-high">close</i>
        <div>Cloud-Based AI Filtering</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-blue-gray-high">close</i>
        <div>API Access</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-blue-gray-high">close</i>
        <div>Enhanced Features</div>
      </div>
    </div>
  </div>
  <div [className]="currentPlanType === 2 ? 'plan current' : 'plan'" style="margin: 0 10px">
    <div class="plan-top">
      <div class="plan-title">Professional
        <div class="current-badge" *ngIf="currentPlanType === 2">Current</div>
      </div>
      <div class="plan-price">
        <div *ngIf="isHasViewPricePermission" style="margin-bottom: 8px; display: flex; align-items: flex-end;">
          <div class="price">{{me()?.currency_symbol}}{{dealerPlanService.dealerPlanPriceProfessional}}</div>
          <div style="display: flex; flex-direction: column; margin-left: 8px">
            <div style="font-size: 14px;">/month per Dealer Account</div>
          </div>
        </div>
        <div class="plan-description">A plan that scales with your rapidly growing business</div>
      </div>
    </div>
    <div class="plan-contents">
      <div style="margin-bottom: 24px; font-size: 14px;">All Basic Features +</div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>Automation Rules</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>90 Days Cloud Video Storage</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>Cloud-Based AI Filtering</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>Local Bridge API</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>Cloud API Access</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>Alarm Incident Report</div>
      </div>
      <div class="plan-action" style="margin-top: 20px;">
        <ng-container *ngIf="me()?.type != 3 && currentPlanType != 2">
          <div class="redirect" (click)="goToPricingPlanDescription()">Go to Detail →</div>
          <button class="primary-button" (click)="onClickShowChangingPlanModal(2)" style="width: 80%; max-width:200px; padding: 10px 25px">Upgrade your account</button>
        </ng-container>
        <ng-container *ngIf="me()?.type === 3 && currentPlanType === 2">
          <button class="primary-button" (click)="goToPricingPlanDescription()" style="width: 80%; max-width:200px; padding: 10px 25px">Go to Detail</button>
        </ng-container>
      </div>
    </div>
  </div>
  <div [className]="currentPlanType === 3 ? 'plan current' : 'plan'" style="margin: 0 10px">
    <div class="plan-top">
      <div class="plan-title">Premium
        <div class="current-badge" *ngIf="currentPlanType === 3">Current</div>
      </div>
      <div class="plan-price">
        <div *ngIf="isHasViewPricePermission" style="margin-bottom: 8px; display: flex; align-items: flex-end;">
          <div class="price">{{me()?.currency_symbol}}{{dealerPlanService.dealerPlanPricePremium}}</div>
          <div style="display: flex; flex-direction: column; margin-left: 8px">
            <div style="font-size: 14px;">/month per Dealer Account</div>
          </div>
        </div>
        <div class="plan-description">Premium services for large-scale site management</div>
      </div>
    </div>
    <div class="plan-contents">
      <div style="margin-bottom: 24px; font-size: 14px;">All Professional Features +</div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>Video Guard Tour</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>1 year of Cloud Video Storage</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>Custom AI Capabilities</div>
      </div>
      <div class="plan-content-description"><i class="material-icons plan-icon text-primary">check</i>
        <div>Lower Video Event Costs</div>
      </div>
      <div class="plan-action">
        <ng-container *ngIf="me()?.type != 3 && currentPlanType != 3">
          <div class="redirect" (click)="goToPricingPlanDescription()">Go to Detail →</div>
          <button class="secondary-button" style="width: 80%; max-width:200px; padding: 10px 25px" (click)="onClickShowChangingPlanModal(3)">Upgrade your account</button>
        </ng-container>
        <ng-container *ngIf="me()?.type === 3 && currentPlanType === 3">
          <button class="secondary-button" style="width: 80%; max-width:200px; padding: 10px 25px" (click)="goToPricingPlanDescription()">Go to Detail</button>
        </ng-container>
      </div>
    </div>
  </div>
</div>